import React from "react";
import { useDispatch } from "react-redux";
import clsx from "clsx";
import { Link, useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Clear";
import EditIcon from "@mui/icons-material/Edit";
import EyeIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import CommentIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";

import styles from "./Post.module.scss";
import { UserInfo } from "../UserInfo";
import { PostSkeleton } from "./Skeleton";
import { fetchRemovePost } from "../../redux/slices/posts";

export const Post = ({
  id,
  slug,
  title,
  createdAt,
  imageUrl,
  videoUrl,
  user,
  viewsCount,
  commentsCount,
  tags,
  children,
  isFullPost,
  isLoading,
  isEditable,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  if (isLoading) {
    return <PostSkeleton />;
  }

  const onClickRemove = () => {
    if (window.confirm("Ви дійсно бажаєте видалити статтю?")) {
      dispatch(fetchRemovePost(id));
    }
  };

  const handleEditClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const confirmEdit = window.confirm("Ви дійсно бажаєте редагувати статтю?");
    if (confirmEdit) {
      navigate(`/posts/${id}/edit`);
    }
  };

  return (
    <div className={clsx(styles.root, { [styles.rootFull]: isFullPost })}>
      {isEditable && (
        <div className={styles.editButtons}>
          <IconButton
            color="primary"
            onClick={handleEditClick}
            component={Link}
            to="#"
          >
            <EditIcon />
          </IconButton>
          <IconButton onClick={onClickRemove} color="secondary">
            <DeleteIcon />
          </IconButton>
        </div>
      )}
      {imageUrl && (
        <div
          style={{
            maxHeight: "90vh",
            display: "flex",
            justifyContent: "center",
            margin: "10px 0",
          }}
        >
          <img
            className={clsx(styles.image, { [styles.imageFull]: isFullPost })}
            src={imageUrl}
            alt={title}
            style={{
              maxHeight: "90vh",
              width: "auto",
              maxWidth: "100%",
              objectFit: "contain",
            }}
          />
        </div>
      )}

      {videoUrl && (
        <div
          style={{
            maxHeight: "90vh",
            display: "flex",
            justifyContent: "center",
            margin: "10px 0",
          }}
        >
          {videoUrl.match(/\.(mp4|webm|ogg)$/i) ? (
            <video
              controls
              src={
                videoUrl.startsWith("http")
                  ? videoUrl
                  : `process.env.REACT_APP_API_URL${videoUrl}`
              }
              style={{
                maxHeight: "90vh",
                maxWidth: "100%",
                objectFit: "contain",
              }}
            />
          ) : (
            <iframe
              src={videoUrl}
              title="Video player"
              style={{
                width: "100%",
                maxHeight: "90vh",
                aspectRatio: "16/9",
                border: "none",
                borderRadius: "10px",
              }}
            />
          )}
        </div>
      )}

      <div className={styles.wrapper}>
        <UserInfo {...user} additionalText={createdAt} />
        <div className={styles.indention}>
          <h2
            className={clsx(styles.title, { [styles.titleFull]: isFullPost })}
          >
            {isFullPost ? title : <Link to={`/posts/${slug || id}`}>{title}</Link>}
          </h2>
          <ul className={styles.tags}>
            {tags.map((name) => (
              <li key={name}>
                <Link to={`/tags/${name}`}>#{name}</Link>
              </li>
            ))}
          </ul>
          {children && <div className={styles.content}>{children}</div>}
          <ul className={styles.postDetails}>
            <li>
              <EyeIcon />
              <span>{viewsCount}</span>
            </li>
            <li>
              <CommentIcon />
              <span>{commentsCount}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
